import { gql } from '@apollo/client'

import { FRAGMENT_RENTAL_ACTIONS } from 'Constants/graphql/fragments/rentalActions'

export const GET_RENTAL = gql`
  query getRental(
    $rentalID: ID!
    $isOrganisationView: Boolean!
    $organisationId: ID
    $employeeId: ID
  ) {
    rental(
      id: $rentalID
      organisationId: $organisationId
      employeeId: $employeeId
    ) {
      id
      deviceID
      deviceDefinitionID
      forcePriceHide
      actions(isOrganisationView: $isOrganisationView) {
        ...rentalActionFields
      }
      alerts(isOrganisationView: $isOrganisationView) {
        showUpgradePossibleAlert
        showLostDeviceReminderAlert
        showEarlyUpgradePossibleAlert
        showProlongingPossibleAlert
        showOpenLostDeviceAlert
        showOpenRepairDeviceAlert
        showOpenCancelDeviceAlert
      }
      minimumContractDuration
      minimumContractDurationDate
      startAt
      endAt
      earlyUpgradeDate
      earliestContractTermination
      isEarlyUpgradeEligible
      amount
      coPaymentAmount
      isBARBContract
      isUpgradeEligible
      isUpgradePending
      isProlongingEligible
      isReplacementDeviceAvailableInDepot
      isScheduledCancellation
      isScheduledCancellationEditable
      isLostStolenNoReplacementEnabled
      newDeviceDate
      upgradeAmount
      poRcn
      customClientReference
      billingIdentifier
      tags {
        id
        name
        color
        inherited
        inheritedFrom
      }
      rentalProlonging {
        validFrom
        validTill
      }
      scheduledCancellationConfig {
        enabled
        leadTime
        fullMonthRentalEnabled
        showDatesFrom
      }
      employee {
        id
        phonePlans {
          phonePlans {
            endAt
            id
            simcardNumber
            startAt
            phoneNumber
            phonePlanTariff {
              name
              logo
            }
          }
        }
        office {
          locationName
          address {
            city
            country
            id
            name
            nameAddition
            street
            zipcode
            streetAddition
          }
          organisation {
            shortName
          }
        }
        contact {
          id
          firstName
          email
          lastName
          phoneNumber
          type
          address {
            city
            country
            id
            name
            nameAddition
            street
            zipcode
            streetAddition
          }
        }
      }
      organisation {
        id
        fullName
        shortName
        individualTermsEN
        individualTermsDE
        contact {
          address {
            city
            country
            id
            name
            nameAddition
            street
            zipcode
            streetAddition
          }
        }
      }
      stocklistItem {
        id
        imei
        imei2
        depot {
          locationName
        }
        eid
        serialNumber
      }
      stocklistItemHistory {
        totalCount
        stocklistItems {
          id
          imei
          serialNumber
          deviceDefinition {
            name
            imageURL
          }
        }
      }
      costCenter {
        name
      }
      rentCategory {
        id
        copaymentNet
        copaymentGross
        descriptionDe
        descriptionEn
        deviceDefinitions {
          deviceDefinitions {
            id
            codename
            color
            imageURL
            manufacturer
            storage
          }
        }
        displaySortOrder
        name
      }
      rentalProlongingPrice {
        basisAmount
        copaymentAmount
        duration
        startDate
        endDate
        prolongAfterInMonths
      }
      caseItems(orderBy: { field: id, order: DESC }) {
        caseItems {
          id
          status
          caseType
          assignedEmployee {
            id
            contact {
              firstName
              lastName
            }
          }
          created
          parentCaseItem {
            id
            status
            caseType
            assignedEmployee {
              id
              contact {
                firstName
                lastName
              }
            }
            created
          }
        }
      }
      parent {
        id
        deviceDefinition {
          name
          imageURL
        }
      }
      children {
        id
        deviceDefinition {
          name
          imageURL
        }
      }
      deviceDefinition {
        id
        name
        codename
        storage
        color
        imageURL
        manufacturer
        productType
      }
    }
  }
  ${FRAGMENT_RENTAL_ACTIONS}
`

export const GET_RENTALS_PREVIEW_COLUMN = gql`
  query getRentalsPreviewColumn($id: ID!) {
    rental(id: $id) {
      amount
      id
      isEarlyUpgradeEligible
      isUpgradeEligible
      isUpgradePending
      minimumContractDuration
      startAt
      coPaymentAmount
      newDeviceDate
      forcePriceHide
      rentalProlonging {
        validFrom
      }
      stocklistItem {
        imei
        imei2
        eid
        serialNumber
      }
      deviceDefinition {
        name
        imageURL
        productType
      }
    }
  }
`
